import { effect, Injectable, signal, WritableSignal } from '@angular/core';
import { getCookie, setCookie} from 'typescript-cookie'
import { environment } from '../../../environments/environment';

export type DisplayMode = 'dark' | 'light' ;
export type UserType = 'teacher' | 'student' ;

@Injectable({
  providedIn: 'root'
})
export class PreferencesService {

  public displayMode: WritableSignal<DisplayMode> ; 

  public userType: WritableSignal<UserType> ;

  constructor() {
    const storedDisplayMode = getCookie('DISPLAY_MODE') ;
    //if (storedDisplayMode == 'dark' || storedDisplayMode == 'light') {
    //  this.displayMode = signal(storedDisplayMode);
    //} else {
      this.displayMode = signal('dark') ;
      
    //}

    /*
    effect(() => {
      setCookie('DISPLAY_MODE', this.displayMode(), {domain:environment.cookieDomain, path: '/'}) ;

      if (this.displayMode() == 'dark') {
          document.body.classList.add('dark');
        } else {
          document.body.classList.remove('dark');
        }
    });
    */
    document.body.classList.add('dark');

    const storedUserType = getCookie('USER_TYPE') ;
    if (storedUserType == 'teacher' || storedUserType == 'student') {
      this.userType = signal(storedUserType);
    } else {
      this.userType = signal('student') ;
    }

    effect(() => {
      setCookie('USER_TYPE', this.userType(), {domain:environment.cookieDomain, path: '/'}) ;
    });
  }

}
